import { render, staticRenderFns } from "./MojProfil.vue?vue&type=template&id=56bd7309&scoped=true&"
import script from "./MojProfil.vue?vue&type=script&lang=ts&"
export * from "./MojProfil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd7309",
  null
  
)

export default component.exports